module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_compare_arrows-cdacdc63c963b4ed67b07446b48bf4f5.svg";